module.exports = __webpack_public_path__ + "275ed4d0d12d076dea62804bb884eaa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner7.png
// module id = 1248
// module chunks = 61